import { Tag } from '~/components/tag'
import { OnSaleContainer } from './on-sale.styles'

const OnSaleTag = ({ children }: { children: string }) => {
  return (
    <OnSaleContainer>
      <Tag.Root variant="on-sale">
        <Tag.Icon symbol="rdicon-arrow-down" />
        <Tag.Label>{children}</Tag.Label>
      </Tag.Root>
    </OnSaleContainer>
  )
}

export { OnSaleTag }
